<script lang="ts" setup>
// Properties
import { debounce } from "perfect-debounce";
import { storeToRefs } from "pinia";
import { onMounted } from "vue";
import { useSearchStore } from "~/store/search"; // Properties

const route = useRoute();
const router = useRouter();

const { selectedState, searchText } = storeToRefs(useSearchStore());
const goToProductSearch = debounce(() => {
    if (!searchText.value) {
        return;
    }

    // If not on product search page, redirect to product search page
    if (
        !router.currentRoute.value.fullPath.includes("/products/state/") &&
        !router.currentRoute.value.fullPath.includes("/products/page/")
    ) {
        if (selectedState.value) {
            navigateTo(`/products/state/${selectedState.value}?search=${searchText.value}`);
            return;
        }

        navigateTo(`/products/state/ga?search=${searchText.value}`);
        return;
    }
}, 1000);

watch(searchText, (newVal, oldVal) => {
    goToProductSearch();
});

onMounted(async () => {
    searchText.value = route.query.search ? String(route.query.search) : searchText.value;
});
</script>

<template>
    <div class="relative flex flex-1 items-center rounded-2xl border border-gray-300 px-4 hover:border-gray-400">
        <input
            v-model="searchText"
            type="text"
            placeholder="Search..."
            class="flex-1 py-1 pl-2 text-base focus:outline-hidden"
        />
        <span
            v-show="!searchText"
            class="flex-none"
        >
            <NuxtImg
                src="/images/header/mag_glass.svg"
                class="w-6"
            />
        </span>
        <span
            v-show="searchText"
            class="flex-none cursor-pointer"
            @click="searchText = ''"
        >
            <NuxtImg
                src="/images/fa/x-regular-duotone.svg"
                class="w-3"
            />
        </span>
    </div>
</template>
